import { Money } from '../../utils/money';
import { User } from '../common/authentication';
import { ExpenseCategory } from './expenses';

export enum RecurrentExpenseNature {
  EXPENSE = 'EXPENSE',
  SALARY = 'SALARY',
}

export enum RecurrentExpenseFrequency {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
}

// RecurrentExpense can either represent an employee salary or a general expense based on the value of nature.
export interface RecurrentExpense {
  id: number;
  name: string;
  nature: RecurrentExpenseNature;
  created_at?: string;
  expense: Money[];
  created_by?: User;
  description: string;
  frequency: RecurrentExpenseFrequency;
  category?: ExpenseCategory;
  start_date?: string;
  end_date?: string;
  next_due_date?: string;
  employee?: User;
  is_active: boolean;
}
